import React from 'react'
import './JoyfullyBold/joyfully-bold-embedded-form.css'
import './JoyfullyBold/joyfully-bold-embedded-help-button.css'

const JoyfullyBoldTheme = () => <React.Fragment></React.Fragment>

export default JoyfullyBoldTheme
